import { render } from "./Plans.vue?vue&type=template&id=97b03646&scoped=true"
import script from "./Plans.vue?vue&type=script&lang=js"
export * from "./Plans.vue?vue&type=script&lang=js"

import "./Plans.vue?vue&type=style&index=0&id=97b03646&scoped=true&lang=scss"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97b03646"]])

export default __exports__